import { useEffect } from 'react';
import PropTypes from 'prop-types';

const DocumentTitle = ({ title, description }) => {
  useEffect(() => {
    // Titre de base
    const baseTitle = "Théophile Yvars - Portfolio | Développeur Full-Stack";
    
    // Mettre à jour le titre
    if (title) {
      document.title = `${title} | Théophile Yvars`;
    } else {
      document.title = baseTitle;
    }
    
    // Mettre à jour la description si fournie
    if (description) {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      }
    }
    
    // Nettoyage : remettre le titre par défaut au démontage
    return () => {
      document.title = baseTitle;
    };
  }, [title, description]);
  
  return null; // Ce composant ne rend rien visuellement
};

DocumentTitle.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default DocumentTitle;
